import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Drawer, Layout, Menu } from "antd";

import { useAppContext } from "@/context/appContext";
import logoIcon from "@/style/images/hny_icon_small.png";
import logoText from "@/style/images/hny_icon.png";

// Import language utilities
import { getCurrentLanguage, t } from "@/utils/language";
import { useLanguage } from "@/context/lang/languageContext";

import {
  MenuOutlined,
  SettingOutlined,
  DashboardOutlined,
  BankOutlined,
  ReadOutlined,
  ShoppingCartOutlined,
  ProjectOutlined,
  RobotOutlined,
  BellOutlined,
  CarOutlined,
  UserOutlined,
  UsergroupAddOutlined,
  SolutionOutlined,
  PayCircleOutlined,
  DiffOutlined,
  CheckSquareOutlined,
  DollarOutlined,
  BranchesOutlined,
  FileDoneOutlined,
  ExportOutlined,
  GlobalOutlined,
  CreditCardOutlined,
  GiftOutlined,
} from "@ant-design/icons";
import {
  AdminPanelSettingsOutlined,
  EventAvailableOutlined,
} from "@mui/icons-material";

import { useSelector, useDispatch } from "react-redux";
import { crud } from "@/redux/crud/actions";
import { selectMenu } from "@/redux/crud/selectors";
import { FingerprintOutlined } from "@material-ui/icons";

const { Sider } = Layout;
const { SubMenu } = Menu;

export default function Navigation() {
  return (
    <>
      <div className="sidebar-wraper">
        <Sidebar collapsible={true} />
      </div>
      <MobileSidebar />
    </>
  );
}

function Sidebar({ collapsible, onMenuClick }) {
  const { state: stateApp, appContextAction } = useAppContext();
  const { isNavMenuClose } = stateApp;
  const { navMenu } = appContextAction;
  const [showLogoApp, setLogoApp] = useState(isNavMenuClose);

  // Get language context
  const { currentLang, isRTL } = useLanguage();

  const dispatch = useDispatch();
  const { result: objMenu, isLoading: listIsLoading } = useSelector(selectMenu);
  useEffect(() => {
    dispatch(crud.menu());
  }, []);

  useEffect(() => {
    if (isNavMenuClose) {
      setLogoApp(isNavMenuClose);
    }
    const timer = setTimeout(() => {
      if (!isNavMenuClose) {
        setLogoApp(isNavMenuClose);
      }
    }, 200);
    return () => clearTimeout(timer);
  }, [isNavMenuClose]);

  const onCollapse = () => {
    navMenu.collapse();
  };

  if (!objMenu) {
    return null;
  }

  return (
    <>
      <Sider
        collapsible={collapsible}
        collapsed={collapsible ? isNavMenuClose : collapsible}
        onCollapse={onCollapse}
        className="navigation"
        // Add RTL support to Sider
        style={{ direction: isRTL ? "rtl" : "ltr" }}
      >
        <div className="logo">
          {showLogoApp && (
            <img
              src={logoIcon}
              alt={t("common.appName")}
              // style={{ margin: "0 auto 40px", display: "block" }}
            />
          )}

          {!showLogoApp && (
            <img
              src={logoText}
              alt={t("common.appName")}
              style={{
                marginTop: "3px",
                marginLeft: isRTL ? "auto" : "10px",
                marginRight: isRTL ? "10px" : "auto",
              }}
            />
          )}
        </div>
        {!listIsLoading && (
          <Menu
            mode="inline"
            className={isRTL ? "rtl-menu" : ""}
            onClick={onMenuClick}
          >
            <Menu.Item key={"Dashboard"} icon={<DashboardOutlined />}>
              <Link to="/">{t("navigation.dashboard")}</Link>
            </Menu.Item>
            {objMenu?.Reservation?.isView ? (
              <Menu.Item key={"Reservation"} icon={<ProjectOutlined />}>
                <Link to="/reservation">{t("navigation.reservation")}</Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {objMenu?.Customer?.isView ? (
              <Menu.Item key={"Customer"} icon={<UserOutlined />}>
                <Link to="/customer">{t("navigation.customer")}</Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {objMenu?.ClientPayment?.isView ? (
              <Menu.Item key={"Payment"} icon={<DollarOutlined />}>
                <Link to="/payment">{t("navigation.payments")}</Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {objMenu?.Car?.isView ? (
              <Menu.Item key={"Car"} icon={<CarOutlined />}>
                <Link to="/car">{t("navigation.car")}</Link>
              </Menu.Item>
            ) : (
              ""
            )}
            <Menu.Item
              key={"availability_list"}
              icon={<EventAvailableOutlined />}
            >
              <Link to="/availability_list">{t("navigation.carCalendar")}</Link>
            </Menu.Item>
            {objMenu?.CarMaintanance?.isView ? (
              <Menu.Item key={"CarMaintanance"} icon={<CarOutlined />}>
                <Link to="/car_maintanance">
                  {t("navigation.carMaintenance")}
                </Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {objMenu?.Employees?.isView ? (
              <Menu.Item key={"Employees"} icon={<UsergroupAddOutlined />}>
                <Link to="/employee">{t("navigation.employees")}</Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {objMenu?.CashTransfer?.isView ? (
              <Menu.Item key={"CashTransfer"} icon={<BranchesOutlined />}>
                <Link to="/transfer_approval">
                  {t("navigation.cashTransfer")}
                </Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {objMenu?.TaskManage?.isView ? (
              <Menu.Item key={"TaskManage"} icon={<SolutionOutlined />}>
                <Link to="/task_management">
                  {t("navigation.taskManagement")}
                </Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {objMenu?.Expenses?.isView ? (
              <Menu.Item key={"Expenses"} icon={<PayCircleOutlined />}>
                <Link to="/expense_entry">{t("navigation.expenses")}</Link>
              </Menu.Item>
            ) : (
              ""
            )}
            {objMenu?.Car?.isView ? (
              <Menu.Item key={"AddOnItem"} icon={<DiffOutlined />}>
                <Link to="/addonitem">{t("navigation.addOnGadgets")}</Link>
              </Menu.Item>
            ) : (
              ""
            )}

            {objMenu?.Transaction?.isView ? (
              <Menu.Item key={"Transaction"} icon={<ReadOutlined />}>
                <Link to="/transaction">{t("navigation.transactions")}</Link>
              </Menu.Item>
            ) : (
              ""
            )}

            <SubMenu
              key={"Settings"}
              icon={<SettingOutlined />}
              title={t("navigation.settings")}
            >
              {objMenu?.["Settings/Settings"]?.isView ? (
                <Menu.Item key={"Settings"} icon={<SettingOutlined />}>
                  <Link to="/settings">{t("navigation.general")}</Link>
                </Menu.Item>
              ) : (
                ""
              )}
              {objMenu?.PromoCode?.isView ? (
                <Menu.Item key={"PromoCode"} icon={<GiftOutlined />}>
                  <Link to="/settings/promo-codes">{t("navigation.promoCodes")}</Link>
                </Menu.Item>
              ) : (
                ""
              )}
              {objMenu?.UserPermission?.isView ? (
                <Menu.Item
                  key={"UserPermission"}
                  icon={<CheckSquareOutlined />}
                >
                  <Link to="/user_permission">
                    {t("navigation.userPermission")}
                  </Link>
                </Menu.Item>
              ) : (
                ""
              )}

              {/* {objMenu?.ServiceData?.isView ? (
                <Menu.Item key={"ServiceData"} icon={<CheckSquareOutlined />}>
                  <Link to="/service_data">
                    {t("navigation.masterServiceData")}
                  </Link>
                </Menu.Item>
              ) : (
                ""
              )} */}

              {objMenu?.Customer?.isView ? (
                <Menu.Item key={"BToBCustomer"} icon={<GlobalOutlined />}>
                  <Link to={"/b2b_customer"} />
                  {t("header.b2b")}
                </Menu.Item>
              ) : (
                ""
              )}
            </SubMenu>

            <SubMenu
              key={"Reports"}
              icon={<RobotOutlined />}
              title={t("navigation.automations")}
            >
              {objMenu?.Salik?.isView ? (
                <Menu.Item key={"SALIK"} icon={<FingerprintOutlined />}>
                  <Link to="/salik_list">{t("navigation.salik")}</Link>
                </Menu.Item>
              ) : (
                ""
              )}
              {(objMenu?.TapPayments?.isView || objMenu?.Salik?.isView) ? (
                <Menu.Item key={"TapPayments"} icon={<CreditCardOutlined />}>
                  <Link to="/tap_payments">{t("navigation.tapPayments")}</Link>
                </Menu.Item>
              ) : (
                ""
              )}
              {objMenu?.Fine?.isView ? (
                <Menu.Item key={"FINE"} icon={<FileDoneOutlined />}>
                  <Link to="/fine_list">{t("navigation.fines")}</Link>
                </Menu.Item>
              ) : (
                ""
              )}
              {objMenu?.Salik?.isView ? (
                <Menu.Item key={"Parking"} icon={<ShoppingCartOutlined />}>
                  <Link to="/parking_list">{t("navigation.parking")}</Link>
                </Menu.Item>
              ) : (
                ""
              )}
              {objMenu?.Salik?.isView ? (
                <Menu.Item key={"Darb1"} icon={<ProjectOutlined />}>
                  <Link to="/darb_list">{t("navigation.darb")}</Link>
                </Menu.Item>
              ) : (
                ""
              )}
              {objMenu?.VatExport?.isView ? (
                <Menu.Item key={"VAT_EXPORT"} icon={<ExportOutlined />}>
                  <Link to="/vat_export">{t("navigation.vatExport")}</Link>
                </Menu.Item>
              ) : (
                ""
              )}
              <Menu.Item key={"NotificationCenter"} icon={<BellOutlined />}>
                <Link to="/notifications">
                  {t("navigation.notificationCenter")}
                </Link>
              </Menu.Item>
              {objMenu["Closing report"]?.isView ? (
                <Menu.Item key={"ClosingReport"}>
                  <Link to="/closing_rpt">{t("navigation.closingReport")}</Link>
                </Menu.Item>
              ) : (
                ""
              )}
              <Menu.Item key={"ClosingReport"}>
                <Link to="">{"__"}</Link>
              </Menu.Item>
            </SubMenu>
          </Menu>
        )}
      </Sider>
    </>
  );
}

function MobileSidebar() {
  const [visible, setVisible] = useState(false);
  const { isRTL } = useLanguage();

  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  return (
    <>
      <Button
        type="text"
        size="large"
        onClick={showDrawer}
        className="mobile-sidebar-btn"
        style={{ float: isRTL ? "right" : "left" }}
      >
        <MenuOutlined />
      </Button>
      <Drawer
        width={200}
        placement={isRTL ? "right" : "left"}
        closable={false}
        onClose={onClose}
        visible={visible}
        className={`mobile-sidebar-wraper ${isRTL ? "rtl-drawer" : ""}`}
      >
        <Sidebar collapsible={false} onMenuClick={onClose} />
      </Drawer>
    </>
  );
}
